type SvgProps = React.SVGProps<SVGSVGElement>;
export const Entity = (props: SvgProps) => (
  <svg
    {...props}
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3054_47969)">
      <g clipPath="url(#clip1_3054_47969)">
        <path
          d="M1.63281 20.9688H21.7578"
          stroke="currentColor"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1328 20.9687V5.15625C13.1328 4.96563 13.0571 4.78281 12.9223 4.64802C12.7875 4.51323 12.6047 4.4375 12.4141 4.4375H3.78906C3.59844 4.4375 3.41562 4.51323 3.28083 4.64802C3.14604 4.78281 3.07031 4.96563 3.07031 5.15625V20.9687"
          stroke="currentColor"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.3203 20.9687V10.9062C20.3203 10.7156 20.2446 10.5328 20.1098 10.398C19.975 10.2632 19.7922 10.1875 19.6016 10.1875H13.1328"
          stroke="currentColor"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.94531 8.03125H8.82031"
          stroke="currentColor"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.38281 13.7812H10.2578"
          stroke="currentColor"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.94531 17.375H8.82031"
          stroke="currentColor"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0078 17.375H17.4453"
          stroke="currentColor"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0078 13.7812H17.4453"
          stroke="currentColor"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3054_47969">
        <rect
          width="23"
          height="25"
          fill="white"
          transform="translate(0.195312 0.5625)"
        />
      </clipPath>
      <clipPath id="clip1_3054_47969">
        <rect
          width="23"
          height="23"
          fill="white"
          transform="translate(0.195312 1.5625)"
        />
      </clipPath>
    </defs>
  </svg>
);
